import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem, Highlight, RowsSkeletonLoader } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { EMBEDDED_CUSTOMER_STATUSES } from '../helpers/constants'
import { UnifiedAssociate } from '../helpers/types'

interface AssociateDetailsProps {
  associatesData: UnifiedAssociate[]
  isLoading: boolean
  isError: boolean
  refetch: () => void
  pendingVerificationStatus: boolean
}

export const AssociateDetails = ({
  associatesData,
  isLoading,
  isError,
  refetch,
  pendingVerificationStatus,
}: AssociateDetailsProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <RowsSkeletonLoader rows={10} />
  }

  if (isError) {
    return (
      <Box paddingX={16} paddingY={32}>
        <RequestErrorStatusCard onReload={refetch} />
      </Box>
    )
  }

  return (
    <Box>
      <h4 className="text-h4 text-foreground-prominent">{t('associates.description')}</h4>
      {pendingVerificationStatus && (
        <Box className="mt-4">
          <p className="text-body-small text-foreground-prominent mt-16">
            {t('associates.pendingVerification')}
          </p>
        </Box>
      )}
      <Box flexCol paddingY={16}>
        {associatesData?.map(associate => (
          <DataListItem
            id={associate?.id}
            title={associate?.title}
            body={associate?.body}
            layout="vertical"
            HeaderHighlight={
              <Highlight
                type={
                  associate?.status === EMBEDDED_CUSTOMER_STATUSES.PENDING ? 'warning' : 'success'
                }
              >
                {associate?.status === EMBEDDED_CUSTOMER_STATUSES.PENDING
                  ? t('embeddedCustomers.status.infoRequired')
                  : t('embeddedCustomers.status.verified')}
              </Highlight>
            }
            key={associate?.id}
          />
        ))}
      </Box>
    </Box>
  )
}
